// Enhanced Fancybox Component for TaskHuman Component Loader
(function() {
    'use strict';
    
    let Fancybox;
    
    // Video URL detection patterns
    const videoPatterns = {
        youtube: /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i,
        vimeo: /(?:vimeo\.com\/)([0-9]+)/i,
        wistia: /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/([a-zA-Z0-9]+)/i,
        dailymotion: /(?:dailymotion\.com\/video\/)([a-zA-Z0-9]+)/i,
        directVideo: /\.(mp4|webm|ogg|mov|avi|wmv|flv|m4v)(?:\?.*)?$/i
    };
    
    function isVideoUrl(url) {
        if (!url) return false;
        
        // Check each pattern
        for (const [platform, pattern] of Object.entries(videoPatterns)) {
            if (pattern.test(url)) {
                return { isVideo: true, platform, url };
            }
        }
        
        return { isVideo: false, platform: null, url };
    }
    
    function convertToEmbedUrl(url, platform) {
        switch (platform) {
            case 'youtube':
                const youtubeMatch = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
                if (youtubeMatch) {
                    return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1&rel=0`;
                }
                break;
            case 'vimeo':
                const vimeoMatch = url.match(/(?:vimeo\.com\/)([0-9]+)/i);
                if (vimeoMatch) {
                    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
                }
                break;
            case 'wistia':
                const wistiaMatch = url.match(/(?:wistia\.com|wi\.st)\/(?:medias|embed)\/([a-zA-Z0-9]+)/i);
                if (wistiaMatch) {
                    return `https://fast.wistia.net/embed/iframe/${wistiaMatch[1]}?autoplay=1`;
                }
                break;
            case 'dailymotion':
                const dailymotionMatch = url.match(/(?:dailymotion\.com\/video\/)([a-zA-Z0-9]+)/i);
                if (dailymotionMatch) {
                    return `https://www.dailymotion.com/embed/video/${dailymotionMatch[1]}?autoplay=1`;
                }
                break;
            case 'directVideo':
                // For direct video files, return as-is for HTML5 video
                return url;
        }
        return url;
    }
    
    function processAllLinks() {
        // Find all links that might be videos
        const allLinks = document.querySelectorAll('a[href]');
        
        allLinks.forEach(link => {
            const href = link.getAttribute('href');
            const videoCheck = isVideoUrl(href);
            
            if (videoCheck.isVideo) {
                // console.log(`Processing video link: ${href} (${videoCheck.platform})`);
                
                // Convert to embed URL
                const embedUrl = convertToEmbedUrl(href, videoCheck.platform);
                
                // Set up fancybox attributes for iframe
                link.setAttribute('data-fancybox', 'video-gallery');
                link.setAttribute('data-type', 'iframe');
                link.setAttribute('data-src', embedUrl);
                
                // Add video platform class for potential styling
                link.classList.add('video-link', `video-${videoCheck.platform}`);
                
                // Don't add click prevention - let Fancybox handle it
                // console.log(`Prepared video link: ${href} -> ${embedUrl}`);
                
            } else {
                // Regular link - ensure it doesn't have fancybox attributes
                link.removeAttribute('data-fancybox');
                link.removeAttribute('data-type');
                link.removeAttribute('data-src');
                
                // Remove video classes if they exist
                link.classList.remove('video-link');
                link.classList.forEach(className => {
                    if (className.startsWith('video-')) {
                        link.classList.remove(className);
                    }
                });
            }
        });
    }
    
    // Load Fancybox if not available
    if (window.Fancybox) {
        Fancybox = window.Fancybox;
        setupFancyboxComponent();
    } else {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.umd.js';
        script.onload = () => {
            Fancybox = window.Fancybox;
            setupFancyboxComponent();
        };
        script.onerror = () => {
            console.error('Fancybox could not be loaded from CDN');
        };
        document.head.appendChild(script);
    }
    
    function setupFancyboxComponent() {
        const fancyboxComponent = {
            init: function(elements) {
                // console.log('Initializing Fancybox with auto video detection');
                // console.log('Passed elements:', elements);
                
                // Process all links for video detection
                processAllLinks();
                
                const defaultOptions = {
                    // Animation options for zoom effect
                    showClass: "fancybox-zoomInUp",
                    hideClass: "fancybox-zoomOutDown",
                    
                    // Let Fancybox handle all sizing automatically
                    autoSize: true,
                    
                    // Video/iframe specific options
                    iframe: {
                        preload: false,
                        // Remove custom CSS - let Fancybox calculate everything
                    },
                    
                    // Remove content padding for cleaner video display
                    contentPadding: 0,
                    
                    // Let Fancybox determine optimal dimensions
                    width: "auto",
                    height: "auto",

                    theme: 'light',
                    
                    // Minimal margins
                    margin: [20, 20],
                    
                    // Clean UI
                    toolbar: {
                        display: {
                            left: [],
                            middle: [],
                            right: ["close"]
                        }
                    },
                    
                    // Improved behavior
                    dragToClose: false,
                    autoFocus: true,
                    trapFocus: true,
                    
                    on: {
                        reveal: (fancybox, slide) => {
                            // console.log('Fancybox revealed:', slide.type, slide.src);
                            // console.log('Content element:', slide.$content);
                            
                            // Let Fancybox handle aspect ratio calculation
                            if (slide.type === 'iframe' && slide.$content) {
                                // Remove any conflicting styles
                                slide.$content.style.padding = '0';
                                slide.$content.style.background = 'rgba(24, 24, 27, 0.9)';
                                
                                // Log computed styles to debug
                                const computedStyle = window.getComputedStyle(slide.$content);
                                console.log('Content computed styles:', {
                                    width: computedStyle.width,
                                    height: computedStyle.height,
                                    aspectRatio: computedStyle.aspectRatio
                                });
                            }
                        },
                        
                        ready: (fancybox, slide) => {
                            // console.log('Fancybox ready - letting it calculate dimensions');
                        }
                    }
                };
                
                try {
                    // Debug: Check what we're trying to bind to
                    const videoLinks = document.querySelectorAll('[data-fancybox="video-gallery"]');
                    // console.log(`Found ${videoLinks.length} video links to bind:`, Array.from(videoLinks));
                    
                    // Log each link's attributes
                    videoLinks.forEach((link, i) => {
                        // console.log(`Link ${i}:`, {
                        //     href: link.href,
                        //     dataSrc: link.getAttribute('data-src'),
                        //     dataType: link.getAttribute('data-type'),
                        //     dataFancybox: link.getAttribute('data-fancybox')
                        // });
                    });
                    
                    // Simple binding with minimal options
                    if (videoLinks.length > 0) {
                        Fancybox.bind('[data-fancybox="video-gallery"]', defaultOptions);
                        // console.log('Fancybox bound to video links successfully');
                    }
                    
                } catch (error) {
                    // console.error('Error initializing Fancybox:', error);
                }
            },
            
            // Method to re-process links (useful for dynamic content)
            refresh: function() {
                // console.log('Refreshing fancybox links...');
                processAllLinks();
                // Re-bind fancybox
                if (Fancybox) {
                    this.init();
                }
            },
            
            // Utility methods
            isVideoUrl: isVideoUrl,
            convertToEmbedUrl: convertToEmbedUrl,
            
            open: function(items, options = {}) {
                if (Fancybox) {
                    return Fancybox.show(items, options);
                }
            },
            
            close: function() {
                if (Fancybox) {
                    Fancybox.close();
                }
            }
        };
        
        // Store component globally so it can be called by the component loader
        window.fancyboxComponent = fancyboxComponent;
        
        // If the component loader has already set up the init function, call it
        if (window.init_fancybox && typeof window.init_fancybox === 'function') {
            window.init_fancybox(fancyboxComponent);
        }
        
        // Set up MutationObserver for dynamic content
        if (typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver((mutations) => {
                let shouldRefresh = false;
                
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        // Check if new links were added
                        const hasNewLinks = Array.from(mutation.addedNodes).some(node => 
                            node.nodeType === 1 && (node.tagName === 'A' || node.querySelector('a'))
                        );
                        
                        if (hasNewLinks) {
                            shouldRefresh = true;
                        }
                    }
                });
                
                if (shouldRefresh) {
                    setTimeout(() => {
                        if (window.fancyboxComponent) {
                            window.fancyboxComponent.refresh();
                        }
                    }, 100);
                }
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }
})();